const getDigits = (value) => value?.toString().replace(/\D/g, '') ?? '';

const getCountryCode = (citizenship) => {
  const code = citizenship?.code?.toString().replace(/\D/g, '');

  return code?.length ? code : '';
};

const getCountryMask = (citizenship) => citizenship?.mask?.toString() ?? '';

const countMaskDigits = (mask) => (mask?.match(/0/g) || []).length;

const applyMask = (digits, mask) => {
  let result = '';
  let digitIndex = 0;

  for (const char of mask || '') {
    if (char === '0') {
      if (digitIndex >= digits.length) {
        break;
      }

      result += digits[digitIndex];
      digitIndex += 1;
      continue;
    }

    result += char;
  }

  return result.trim();
};

export const getPhoneMask = (citizenship) => {
  const code = getCountryCode(citizenship);
  const mask = getCountryMask(citizenship);

  if (!code || !mask) {
    return '+7 (###) ### ## ##';
  }

  return `+${code} ${mask.replace(/0/g, '#')}`;
};

export const stripCountryCodeFromPhone = (phone, citizenship) => {
  const digits = getDigits(phone);
  const code = getCountryCode(citizenship);

  if (!digits || !code) {
    return digits;
  }

  return digits.startsWith(code) ? digits.slice(code.length) : digits;
};

export const formatPhoneNumber = (phoneNumber, citizenship) => {
  const digits = getDigits(phoneNumber);

  if (!digits) {
    return '-';
  }

  const code = getCountryCode(citizenship);
  const mask = getCountryMask(citizenship);

  if (!code || !mask) {
    if (digits.length !== 10) {
      return phoneNumber;
    }

    const countryCode = '+7';
    const areaCode = digits.substring(0, 3);
    const firstPart = digits.substring(3, 6);
    const secondPart = digits.substring(6, 8);
    const thirdPart = digits.substring(8, 10);

    return `${countryCode} (${areaCode}) ${firstPart}-${secondPart}-${thirdPart}`;
  }

  const localDigits = stripCountryCodeFromPhone(digits, citizenship);
  const maxDigits = countMaskDigits(mask);
  const phoneDigits = localDigits.slice(0, maxDigits);

  return `+${code} ${applyMask(phoneDigits, mask)}`.trim();
};
